import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import mdEntityService from "core/metamodel/mdEntityService";
import commonService from 'core/common/service/commonService';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {lovLabel, lovValue} from "core/form/formUtils";
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import {observable, action, ObservableMap} from "mobx";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import Grid from "core/grid/domain/grid";
import {observer} from "mobx-react";
import uiService from "core/common/service/uiService";
import {DialogProps, SteppingDialogAncestor} from "core/common/page/dialogAncestor";
import {ActivityConfig, ActivityTemplate, ACTIVITYTYPE, GridActivityDto} from "core/event/eventDomain";
import gridService from "core/grid/gridService";
import {PartyActivityTable} from "core/event/component/historyBlocks";
import EmailBodyEditor from "core/components/editors/emailBodyEditor";
import {EditorState} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import eventService from "core/event/eventService";
import {stateFromHTML} from 'draft-js-import-html';
import {HtmlThumbnail} from "core/event/component/htmlThumbnail";



@observer
export default class GenerateActivityDialog extends SteppingDialogAncestor<DialogProps, undefined, any> {


  @observable private gridActivityDto: GridActivityDto;
  @observable private grid: Grid;
  @observable private editorState: EditorState;
  private activityTemplates: ActivityTemplate[];
  @observable private selectedTemplateIndex: number;

  @action open(resolve, reject, grid: Grid, activityConfigLov: LovItem) {
    let {entities} = this.props;

    uiService.showToolbarActionFlag();

    this.selectedTemplateIndex = undefined;

    let gridParams = grid.createFullParams();

    console.log('GenerateActivityDialog: Opening dialog for ', gridParams);

    this.resolve = resolve;
    this.reject = reject;
    this.grid = grid;




    Promise.all([mdEntityService.fetchEntities([{entity: "ACTIVITYTYPE", lov: true}]), eventService.readActivityTemplates(lovValue(activityConfigLov))])
      .then(([entities, activityTemplates]: [ObservableMap<MdEntity>, ActivityTemplate[]]) => {
        this.activityTemplates = activityTemplates;

        this.gridActivityDto = new GridActivityDto({
          activityConfigId: lovValue(activityConfigLov),
          gridId: grid.getActiveGridConfig().gridId,
          type: mdEntityService.getEntity("ACTIVITYTYPE").getLovItem(ACTIVITYTYPE.EMAIL),
          part: 1,
          gridParams: gridParams,
        });

        if (activityTemplates.length === 1) {
          this.selectedTemplateIndex = 0;
          this.handleThumbnail(0);
        }

        this.dialogOpen = true;
        uiService.hideToolbarActionFlag();
      })
      .catch(error => {
        this.reject(error);
      });

  }


  @action prepare = () => {
    console.log('Preparing generate activity');

    commonService.loading(true);

    let activityTemplate = this.activityTemplates[this.selectedTemplateIndex];
    if (!activityTemplate.defaultEmailDesign) this.gridActivityDto.bodyTemplate = stateToHTML(this.editorState.getCurrentContent());

    gridService.generateActivity(this.grid, this.gridActivityDto, 1)
      .then(action("prepare-action", (newGridActivityDto: GridActivityDto) => {
        commonService.loading(false);
        this.gridActivityDto.part = 2;
        this.gridActivityDto.showErrors = true;
        this.gridActivityDto.statuses = newGridActivityDto.statuses;
      }), error => {
        this.$errors = error.getMessages();
      });

  };

  @action ok = () => {
    console.log('Issuing invoices');

    commonService.loading(true);

    let activityTemplate = this.activityTemplates[this.selectedTemplateIndex];
    if (!activityTemplate.defaultEmailDesign) this.gridActivityDto.bodyTemplate = stateToHTML(this.editorState.getCurrentContent());

    gridService.generateActivity(this.grid, this.gridActivityDto, 2)
      .then(action("generate-action", (newGridActivityDto: GridActivityDto) => {
        commonService.loading(false);
        newGridActivityDto.part = 3;
        newGridActivityDto.showErrors = false;
        this.gridActivityDto = newGridActivityDto;
      }), error => {
        this.$errors = error.getMessages();
      });
  };

  @action close = () => {
    this.gridActivityDto = null;
    this.resolve(null);
  };

  @action cancel = (evt) => {
    console.log('GenerateActivityDialog#cancel evt = %O', evt);
    this.gridActivityDto = null;
    this.reject(null);
  };

  @action onShowErrors = (evt) => {
    this.gridActivityDto.showErrors = evt.target.checked;
  };

  @action onChangeSubject = (evt) => {
    this.gridActivityDto.subjectTemplate = evt.target.value;
  };
  @action onChangeBody = (editorState) => {
    this.editorState = editorState;
  };


  componentWillUnmount() {
    this.gridActivityDto = null;
  }


  render() {

    let {entities} = this.props;

    if (!(this.gridActivityDto && this.dialogOpen)) return null;


    let cancelButton = <FlatButton label="Cancel" key={0} tabIndex={0} primary onClick={this.cancel} />;

    let showErrorCheckbox = <MdCheckbox key={1} label="Show Errors" checked={this.gridActivityDto.showErrors} labelStyle={{whiteSpace: 'nowrap'}} style={{display: 'inline-block', width: 140, verticalAlign: 'middle'}} onCheck={this.onShowErrors} />;

    let actions;

    if (this.gridActivityDto.part === 1) {
      actions = [cancelButton, <FlatButton key={2} label={`Prepare ${lovLabel(this.gridActivityDto.type)}`} secondary onClick={this.prepare}/>];
    } else if (this.gridActivityDto.part === 2) {
      actions = [showErrorCheckbox, cancelButton,
        <FlatButton key={2} label="Recheck" secondary onClick={this.prepare}/>, <FlatButton key={3} label={`Send ${lovLabel(this.gridActivityDto.type)} !`} secondary onClick={this.ok} />];
    } else if (this.gridActivityDto.part === 3) {
      actions = [showErrorCheckbox, <FlatButton key={2} label="Close" primary onClick={this.close} />];
    }


    console.debug("rendering GenerateActivityDialog ", this.gridActivityDto);


    return (
      <Dialog
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: '80%', maxWidth: 800}}
        bodyStyle={{overflow: 'auto'}}
      >


        <Stepper activeStep={this.gridActivityDto.part - 1}>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> Check </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> Generate </StepLabel>
          </Step>
          <Step>
            <StepLabel className="mui-stepper-icon-hack"> Done </StepLabel>
          </Step>
        </Stepper>



        <ErrorComp messages={this.$errors}/>

        {
          (this.gridActivityDto.part === 1) ?
                (this.selectedTemplateIndex == null) ? (
                    <div style={{marginLeft:10}}>
                      {this.activityTemplates.map((at, i) => (<HtmlThumbnail html={at.defaultEmailBody} onClick={this.handleThumbnail.bind(this,i)} key={i}/>))}
                    </div>
                ) : (
                  <div style={{marginLeft:10}}>
                    <MdTextField  value={this.gridActivityDto.subjectTemplate} onChange={this.onChangeSubject} fullWidth hintText="Subject" />
                    {
                      (this.activityTemplates[this.selectedTemplateIndex].defaultEmailDesign) ? (
                        <div dangerouslySetInnerHTML={{__html: this.activityTemplates[this.selectedTemplateIndex].defaultEmailBody}}/>
                        ) : (
                        <EmailBodyEditor editorState={this.editorState} onChange={this.onChangeBody} style={{height: 500}}/>
                      )
                    }

                  </div>
                )
            : (
            <div style={{overflowY: 'auto', maxHeight:500, fontSize: 13}}>
              <PartyActivityTable statuses={this.gridActivityDto.statuses} showErrors={this.gridActivityDto.showErrors} />
            </div>
          )
        }



      </Dialog>
    );
  }

  @action handleThumbnail = (index: number) => {
    this.selectedTemplateIndex = index;
    let activityTemplate = this.activityTemplates[index];
    this.gridActivityDto.subjectTemplate = activityTemplate.defaultEmailSubject;
    this.gridActivityDto.bodyTemplate = activityTemplate.defaultEmailBody;

    if (!activityTemplate.defaultEmailDesign) {
      this.editorState = (activityTemplate.defaultEmailBody) ? EditorState.createWithContent(stateFromHTML(activityTemplate.defaultEmailBody)) : EditorState.createEmpty();
    }
  };




}






// WEBPACK FOOTER //
// ./src/core/event/component/generateActivityDialog.tsx